/* =======================================================================
   assets/collection-shop.js
   GD Lingerie shop page — Shopify version (4 Items Per Page)
   ======================================================================= */

function GDstars(n) { return '★★★★★☆☆☆☆☆'.slice(5 - n, 10 - n); }

function GDfmt(cents) {
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
}

var GD_COLOR_HEX = {
  'crimson': '#C2001C', 'red': '#C2001C',
  'noir': '#111114', 'black': '#111114',
  'blanc': '#EDE3D6', 'ivory': '#EDE3D6', 'white': '#EDE3D6',
  'sapphire': '#1E3A8A', 'blue': '#1E3A8A',
  'plum': '#5B1A3A', 'purple': '#5B1A3A',
  'ember': '#B5451B'
};
function colorHex(name) {
  var key = (name || '').toLowerCase().trim();
  for (var k in GD_COLOR_HEX) { if (key.indexOf(k) !== -1) return GD_COLOR_HEX[k]; }
  return '#999';
}

/* ---------------- Cart (Shopify AJAX Cart API) ---------------- */
var Cart = {
  async get() {
    var res = await fetch('/cart.js');
    return res.json();
  },
  async add(variantId, qty) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    return Cart.refresh();
  },
  async setQty(lineKey, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    return Cart.refresh();
  },
  async remove(lineKey) { return Cart.setQty(lineKey, 0); },
  async refresh() {
    var cart = await Cart.get();
    Cart.renderBadges(cart);
    Cart.renderDrawer(cart);
    document.dispatchEvent(new CustomEvent('gd:cart-change', { detail: cart }));
    return cart;
  },

  renderBadges(cart) {
    var n = cart.item_count;
    document.querySelectorAll('.bag-count').forEach(function (el) { el.textContent = n; });
  },

  injectDrawer() {
    if (document.getElementById('cartDrawer')) return;
    var el = document.createElement('div');
    el.id = 'cartDrawer';
    el.className = 'drawer';
    el.innerHTML =
      '<div class="drawer-scrim" data-drawer-close></div>' +
      '<div class="drawer-panel">' +
        '<div class="drawer-head">' +
          '<h3>Your Bag <span id="cdCount"></span></h3>' +
          '<button class="drawer-x" data-drawer-close aria-label="Close bag">&times;</button>' +
        '</div>' +
        '<div class="drawer-body" id="cdBody"></div>' +
        '<div class="drawer-foot" id="cdFoot">' +
          '<div class="sum-row"><span>Subtotal</span><span id="cdSubtotal">$0.00</span></div>' +
          '<a href="/cart" class="btn btn-outline btn-block" data-hov>View Bag</a>' +
          '<a href="/checkout" class="btn btn-primary btn-block" data-hov style="margin-top:12px">Checkout <span class="arrow">→</span></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    el.querySelectorAll('[data-drawer-close]').forEach(function (x) {
      x.addEventListener('click', Cart.closeDrawer);
    });
  },

  renderDrawer(cart) {
    var body = document.getElementById('cdBody');
    var foot = document.getElementById('cdFoot');
    var countEl = document.getElementById('cdCount');
    if (!body) return;

    countEl.textContent = '(' + cart.item_count + ')';

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="drawer-empty">' +
          '<div class="glyph">GD</div>' +
          '<p>Your bag is empty.</p>' +
          '<a href="' + (window.GD_SHOP_URL || '/collections/all') + '" class="btn btn-primary" data-hov>Shop the Collection <span class="arrow">→</span></a>' +
        '</div>';
      foot.style.display = 'none';
      return;
    }

    foot.style.display = '';
    body.innerHTML = cart.items.map(function (i) {
      return (
        '<div class="drawer-item">' +
          '<img src="' + i.image + '" alt="' + i.product_title + '">' +
          '<div class="di-info">' +
            '<h4>' + i.product_title + '</h4>' +
            '<div class="meta">' + i.variant_title + '</div>' +
            '<div class="di-row">' +
              '<div class="qty-stepper mini">' +
                '<button data-qty-down="' + i.key + '" aria-label="Decrease">−</button>' +
                '<span>' + i.quantity + '</span>' +
                '<button data-qty-up="' + i.key + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="di-price">' + GDfmt(i.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="di-remove" data-remove="' + i.key + '" aria-label="Remove">&times;</button>' +
        '</div>'
      );
    }).join('');

    document.getElementById('cdSubtotal').textContent = GDfmt(cart.total_price);

    body.querySelectorAll('[data-qty-up]').forEach(function (b) {
      b.addEventListener('click', function () {
        var item = cart.items.find(function (x) { return x.key === b.getAttribute('data-qty-up'); });
        if (item) Cart.setQty(item.key, item.quantity + 1);
      });
    });
    body.querySelectorAll('[data-qty-down]').forEach(function (b) {
      b.addEventListener('click', function () {
        var item = cart.items.find(function (x) { return x.key === b.getAttribute('data-qty-down'); });
        if (item) Cart.setQty(item.key, item.quantity - 1);
      });
    });
    body.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { Cart.remove(b.getAttribute('data-remove')); });
    });
  },

  openDrawer() {
    Cart.injectDrawer();
    Cart.refresh();
    document.getElementById('cartDrawer').classList.add('open');
    document.body.classList.add('drawer-lock');
  },
  closeDrawer() {
    var d = document.getElementById('cartDrawer');
    if (d) d.classList.remove('open');
    document.body.classList.remove('drawer-lock');
  }
};

/* ---------------- Wishlist (localStorage) ---------------- */
var WISH_KEY = 'gd_wishlist_v1';
var Wishlist = {
  read() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } },
  write(ids) {
    localStorage.setItem(WISH_KEY, JSON.stringify(ids));
    Wishlist.renderBadges();
    document.dispatchEvent(new CustomEvent('gd:wishlist-change', { detail: ids }));
  },
  has(id) { return Wishlist.read().includes(String(id)); },
  toggle(id) {
    id = String(id);
    var ids = Wishlist.read();
    if (ids.includes(id)) ids = ids.filter(function (x) { return x !== id; });
    else ids.push(id);
    Wishlist.write(ids);
    return ids.includes(id);
  },
  count() { return Wishlist.read().length; },
  renderBadges() {
    var n = Wishlist.count();
    document.querySelectorAll('.wish-count').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      btn.classList.toggle('active', Wishlist.has(btn.getAttribute('data-wish-toggle')));
    });
  }
};

/* ---------------- Quick View ---------------- */
var QuickView = {
  inject() {
    if (document.getElementById('qvModal')) return;
    var el = document.createElement('div');
    el.id = 'qvModal';
    el.className = 'drawer qv-modal';
    el.innerHTML =
      '<div class="drawer-scrim" data-qv-close></div>' +
      '<div class="qv-panel">' +
        '<button class="drawer-x" data-qv-close aria-label="Close quick view">&times;</button>' +
        '<div class="qv-grid">' +
          '<div class="qv-img"><img id="qvImg" src="" alt=""></div>' +
          '<div class="qv-info">' +
            '<span class="cat" id="qvCat"></span>' +
            '<h3 id="qvName"></h3>' +
            '<div class="pdp-price" id="qvPrice"></div>' +
            '<p id="qvDesc"></p>' +
            '<div id="qvOptions"></div>' +
            '<div class="pdp-cta">' +
              '<button class="btn btn-primary" id="qvAdd" data-hov>Add to Bag <span class="arrow">→</span></button>' +
              '<button class="wish-btn" id="qvWish" data-hov aria-label="Add to wishlist">♥</button>' +
            '</div>' +
            '<a id="qvViewFull" href="#" data-hov>View Full Details →</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    el.querySelectorAll('[data-qv-close]').forEach(function (x) { x.addEventListener('click', QuickView.close); });
  },

  async open(handle) {
    QuickView.inject();
    var res = await fetch('/products/' + handle + '.js');
    if (!res.ok) return;
    var p = await res.json();

    var state = { selections: [], variant: null };
    var defaultVariant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    state.selections = [defaultVariant.option1, defaultVariant.option2, defaultVariant.option3];

    function findVariant(sel) {
      return p.variants.find(function (v) {
        return v.option1 == sel[0] && v.option2 == sel[1] && v.option3 == sel[2];
      });
    }

    function renderOptions() {
      var wrap = document.getElementById('qvOptions');
      wrap.innerHTML = '';
      p.options.forEach(function (optionRaw, idx) {
        var optionName = (optionRaw && typeof optionRaw === 'object')
          ? (optionRaw.name || optionRaw.value || '')
          : optionRaw;

        var values = p.variants
          .map(function (v) { return v['option' + (idx + 1)]; })
          .filter(function (v, i, arr) { return v && arr.indexOf(v) === i; });

        var isColor = /colou?r/i.test(optionName);

        // FIX: label ke aage selected value dikhane ke liye span add kiya
        var block = document.createElement('div');
        block.className = 'opt-block';
        block.innerHTML =
          '<div class="opt-label"><span>' + optionName + ' — <span class="qv-selected-val" data-opt-idx="' + idx + '">' +
          (state.selections[idx] || '') + '</span></span></div>' +
          '<div class="' + (isColor ? 'swatches' : 'sizes') + '" data-option-index="' + idx + '"></div>';
        wrap.appendChild(block);

        var group = block.querySelector(isColor ? '.swatches' : 'sizes'.replace('sizes', '.sizes'));

        values.forEach(function (valRaw) {
          var val = (valRaw && typeof valRaw === 'object')
            ? (valRaw.name || valRaw.value || '')
            : valRaw;

          var testSel = state.selections.slice();
          testSel[idx] = val;
          var available = p.variants.some(function (v) {
            return v.available &&
              (idx !== 0 || v.option1 == val) &&
              (idx !== 1 || v.option2 == val) &&
              (idx !== 2 || v.option3 == val);
          });

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.dataset.hov = '';
          btn.disabled = !available;
          if (isColor) {
            btn.className = 'swatch' + (state.selections[idx] === val ? ' active' : '');
            btn.style.setProperty('--sw', colorHex(val));
            btn.setAttribute('aria-label', val);
          } else {
            btn.className = 'size-chip' + (state.selections[idx] === val ? ' active' : '');
            btn.textContent = val;
          }
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            state.selections[idx] = val;

            // FIX: click hote hi label ke aage wali value turant update ho jaye
            var labelSpan = document.querySelector('.qv-selected-val[data-opt-idx="' + idx + '"]');
            if (labelSpan) labelSpan.textContent = val;

            renderOptions();
            updateVariant();
          });
          group.appendChild(btn);
        });
      });
    }

    function updateVariant() {
      var variant = findVariant(state.selections);
      state.variant = variant;
      var priceEl = document.getElementById('qvPrice');
      var addBtn = document.getElementById('qvAdd');

      if (variant) {
        priceEl.innerHTML = variant.compare_at_price > variant.price
          ? '<s>' + GDfmt(variant.compare_at_price) + '</s> ' + GDfmt(variant.price)
          : GDfmt(variant.price);
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      } else {
        priceEl.textContent = GDfmt(p.price);
        addBtn.disabled = true;
        addBtn.textContent = 'Select options';
      }
    }

    document.getElementById('qvImg').src = p.featured_image || (p.images[0] || '');
    document.getElementById('qvImg').alt = p.title;
    document.getElementById('qvCat').textContent = p.type || p.vendor || '';
    document.getElementById('qvName').textContent = p.title;
    document.getElementById('qvDesc').textContent = (p.description || '').replace(/<[^>]+>/g, '').slice(0, 220);
    document.getElementById('qvViewFull').href = p.url;

    renderOptions();
    updateVariant();

    var wishBtn = document.getElementById('qvWish');
    wishBtn.classList.toggle('active', Wishlist.has(p.id));
    wishBtn.onclick = function () { wishBtn.classList.toggle('active', Wishlist.toggle(p.id)); };

    document.getElementById('qvAdd').onclick = async function () {
      if (!state.variant || !state.variant.available) return;
      await Cart.add(state.variant.id, 1);
      QuickView.close();
      Cart.openDrawer();
    };

    document.getElementById('qvModal').classList.add('open');
    document.body.classList.add('drawer-lock');
  },

  close() {
    var d = document.getElementById('qvModal');
    if (d) d.classList.remove('open');
    document.body.classList.remove('drawer-lock');
  }
};

/* ================= Collection filter / sort / pagination (4 Items Per Page) ================= */
(function () {
  var pillsWrap = document.getElementById('filterPills');
  var grid = document.getElementById('shopGrid');
  if (!pillsWrap || !grid) return;

  var allCards = Array.prototype.slice.call(grid.children);
  var resultCountEl = document.getElementById('resultCount');
  var emptyStateEl = document.getElementById('emptyState');
  var paginationEl = document.getElementById('shopPagination');
  var sortSelect = document.getElementById('sortSelect');

  // UPDATED: Now set to 24 products per page
  var PAGE_SIZE = 24; 
  var state = { filter: 'all', sort: 'featured', page: 1 };

  function slugify(text) {
    return (text || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-');
  }

  function matchesFilter(card) {
    if (state.filter === 'all' || state.filter === '') return true;

    var filterValue = slugify(state.filter);
    
    // Check tags
    var rawTags = card.getAttribute('data-tags') || '';
    var tags = rawTags.split(',').map(function(t) { return slugify(t); });
    
    // Check collections
    var rawCols = card.getAttribute('data-collections') || '';
    var cols = rawCols.split(',').map(function(c) { return slugify(c); });

    return tags.includes(filterValue) || cols.includes(filterValue);
  }

  function getFiltered() {
    return allCards.filter(matchesFilter);
  }

  function getSorted(list) {
    var arr = list.slice();
    if (state.sort === 'price-asc') {
      arr.sort(function (a, b) { return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')); });
    } else if (state.sort === 'price-desc') {
      arr.sort(function (a, b) { return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')); });
    } else if (state.sort === 'newest') {
      arr.sort(function (a, b) { return parseInt(b.getAttribute('data-created'), 10) - parseInt(a.getAttribute('data-created'), 10); });
    }
    return arr;
  }

  function render() {
    var filtered = getSorted(getFiltered());
    var totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    if (state.page > totalPages) state.page = totalPages;

    var start = (state.page - 1) * PAGE_SIZE;
    var pageItems = filtered.slice(start, start + PAGE_SIZE);

    allCards.forEach(function (card) { card.style.display = 'none'; });
    pageItems.forEach(function (card) {
      card.style.display = '';
      grid.appendChild(card);
    });

    if (resultCountEl) {
      resultCountEl.textContent = filtered.length + (filtered.length === 1 ? ' piece' : ' pieces');
    }
    if (emptyStateEl) {
      emptyStateEl.style.display = filtered.length === 0 ? '' : 'none';
    }

    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    if (!paginationEl) return;
    if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

    var html = '<button class="nav-arrow" data-hov data-page="prev" aria-label="Previous page"' +
      (state.page === 1 ? ' disabled' : '') + '>‹</button>';

    for (var p = 1; p <= totalPages; p++) {
      html += '<button data-hov class="page-num ' + (p === state.page ? 'active' : '') + '" data-page="' + p + '">' + p + '</button>';
    }

    html += '<button class="nav-arrow" data-hov data-page="next" aria-label="Next page"' +
      (state.page === totalPages ? ' disabled' : '') + '>›</button>';

    paginationEl.innerHTML = html;
  }

  pillsWrap.addEventListener('click', function (e) {
    var pill = e.target.closest('.pill') || e.target.closest('[data-filter]');
    if (!pill) return;
    pillsWrap.querySelectorAll('.pill, [data-filter]').forEach(function (p) { p.classList.remove('active'); });
    pill.classList.add('active');
    state.filter = pill.getAttribute('data-filter');
    state.page = 1;
    render();
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      state.page = 1;
      render();
    });
  }

  if (paginationEl) {
    paginationEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page]');
      if (!btn || btn.hasAttribute('disabled')) return;
      var val = btn.getAttribute('data-page');
      if (val === 'prev') state.page -= 1;
      else if (val === 'next') state.page += 1;
      else state.page = parseInt(val, 10);
      render();
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  render();
})();

/* ================= Global Wire-Up ================= */
document.addEventListener('DOMContentLoaded', function () {
  Cart.injectDrawer();
  Cart.refresh();
  Wishlist.renderBadges();
});

document.addEventListener('click', function (e) {
  var bagToggle = e.target.closest('[data-bag-toggle]');
  if (bagToggle) { e.preventDefault(); Cart.openDrawer(); return; }

  var qvTrigger = e.target.closest('[data-quickview-id]');
  if (qvTrigger) { e.preventDefault(); QuickView.open(qvTrigger.getAttribute('data-quickview-id')); return; }

  var wishTrigger = e.target.closest('[data-wish-toggle]');
  if (wishTrigger) {
    e.preventDefault();
    wishTrigger.classList.toggle('active', Wishlist.toggle(wishTrigger.getAttribute('data-wish-toggle')));
    return;
  }

  var addTrigger = e.target.closest('[data-add-id]');
  if (addTrigger) {
    e.preventDefault();
    addTrigger.disabled = true;
    Cart.add(addTrigger.getAttribute('data-add-id'), 1).then(function () {
      addTrigger.disabled = false;
      Cart.openDrawer();
    });
    return;
  }

  if (e.target.closest('[data-qv-close]') || e.target.classList.contains('drawer-scrim')) {
    QuickView.close();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') { QuickView.close(); Cart.closeDrawer(); }
});